<template>
  <div>
    <!-- Navbar -->
    <nav class="bg-gray-100 p-4">
      <ul class="flex space-x-4">
        <li>
          <router-link to="/" class="hover:text-sky-600">Home</router-link>
        </li>
      </ul>
    </nav>

    <!-- Router View -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
